import React, { useState, useEffect } from "react"

import styles from '../page_css/BigBassSlots.module.css';

//Components
import CherryspinsHeaderAslan from "../components/CherryspinsHeaderAslan"
import BigBassSlotsComponent from "../components/BigBassSlotsComponent"
import OroLoader from "../components/OroLoader"

export default function BigBassSlots() {

    useEffect(() => {
        // console.log(imgDesktopBackground)
    });

    return (
        <section className={styles.pageWrapper} >
            <CherryspinsHeaderAslan />
            <BigBassSlotsComponent bannerImageType="standard"/>
            <OroLoader />
        </section>
    )
}